import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export function Field({ label, children }) {
  return (
    <div className="space-y-1">
      <Label className="text-[10px] font-mono uppercase tracking-wider text-ink4">
        {label}
      </Label>
      {children}
    </div>
  );
}

export function NumberInput({ value, onChange, testId, step = 1, disabled = false }) {
  return (
    <Input
      type="number"
      step={step}
      value={value ?? 0}
      onChange={(e) => onChange(Number(e.target.value))}
      disabled={disabled}
      data-testid={testId}
      className={`h-8 rounded-none bg-chrome border-line text-foreground text-sm ${disabled ? "opacity-40 cursor-not-allowed" : ""}`}
    />
  );
}

export function ColorInput({ value, onChange, testId }) {
  return (
    <div className="flex gap-2 items-center">
      <input
        type="color"
        value={value && value !== "none" ? value : "#000000"}
        onChange={(e) => onChange(e.target.value)}
        data-testid={testId}
        className="w-8 h-8 bg-chrome border border-line cursor-pointer"
      />
      <Input
        value={value || ""}
        onChange={(e) => onChange(e.target.value)}
        className="h-8 rounded-none bg-chrome border-line text-foreground text-sm flex-1 font-mono"
      />
    </div>
  );
}

export function PanelSection({ title, children }) {
  return (
    <section>
      <h3 className="text-[10px] font-mono uppercase tracking-widest text-ink4 mb-2">
        {title}
      </h3>
      {children}
    </section>
  );
}
